import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';
import { useTranslation } from 'react-i18next';
import { getSignedUrl } from '../../../lib/fetch/files';
import SupplierAdminPresentational from './SupplierAdminPresentational';
import axios from 'axios';

const SupplierAdmin = (props) => {
  const [t] = useTranslation('EXTERNAL_AGREEMENTS');
  const [{ newToken, profile = {} } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  const [activities, setActivities] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const fetchAdmins = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/admins`,
      {
        headers: { Authorization: newToken },
        params: { search: value },
      }
    );

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    return data;
  };

  const fetchActivities = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/activities`,
      {
        headers: { Authorization: newToken },
        params: {
          limit: 9999,
          offset: 0,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;

    setActivities(data.activities);
  };

  const fetchSuppliers = async (activityId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/agreements/suppliers`,
      {
        headers: { Authorization: newToken },
        params: { activityId },
      }
    );

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;

    setSuppliers(data.suppliers);
  };

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  async function handleDelete({ agreementId }) {
    showLoading();

    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/external-agreements/${agreementId}`,
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    hideLoading();
    alert.success(t('COMMON:SUCCESS_DELETE'));
  }

  useEffect(() => {
      fetchActivities();
    }, []);

  return (
    <SupplierAdminPresentational
      activities={activities}
      suppliers={suppliers}
      fetchSuppliers={fetchSuppliers}
      fetchAdmins={fetchAdmins}
      handleDelete={handleDelete}
      handleFileListView={handleFileListView}
      {...props}
    />
  );
};

export default SupplierAdmin;
